import { deepmergeCustom } from 'deepmerge-ts';
import type { PartialDeep } from 'type-fest';

import { filterEmpty } from '../lists/filterEmpty';

/**
 * By default deepmerge will filter out values like undefined
 * This overrides that behavior so that we can pass in undefined to overwrite values
 */
const mergeAllButArrays = deepmergeCustom({
	filterValues: false,

	// Don't merge arrays or sets
	mergeArrays: false,
	mergeSets: false,
});

const mergeEverything = deepmergeCustom({
	filterValues: false,
});

export function deepMergePartial<T>(values: Array<PartialDeep<T> | Partial<T> | T>, mergeAll = false): T {
	// Just return an empty object if the list is empty / undefined
	if (!values?.length) {
		return {} as T;
	}

	// Ignore empty values
	let mergeList = filterEmpty(values);
	// Cast values as the final output class
	mergeList = mergeList.map((value) => value as T);

	// Return everything merged (or a blank object if there's nothing after merging)
	let merged: T;
	if (mergeAll) {
		merged = mergeEverything(...mergeList) as T;
	} else {
		merged = mergeAllButArrays(...mergeList) as T;
	}
	merged ??= {} as T;

	// Return back the values merged, with a cast at the end
	return merged;
}
